export const TRIGGER_OVERLAY = 'TRIGGER_OVERLAY';



// WEBPACK FOOTER //
// ./src/store/Overlay/types.js